<template>
  <div id="app" :class="{'app-en':isEN=='en'}" @click="clickMk()">
    <router-view/>
	<!-- loading -->
	<div class="modal" v-if="showLoad">
		<div class="modal-bg"></div>
		<div class="modal-content" style="width:100%;left:0;">
			<div class="loadBox ac">
				<div class="load-bg"></div>
				<div class="loadCont">
					<img src="static/images/loading.gif"/>
					<p>{{$t('pleaseWait')}} ...</p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import AudioService from '@/services/AudioService'
export default {
  name: 'App',
  data(){
	return{
		showLoad:false,
    isEN:'bur',
    audioService: AudioService,
    isBgmPlaying: false,
	}
  },
  created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if(localStorage.getItem('BackgroundMusic')==null){
      localStorage.setItem('BackgroundMusic', 'true');
    }
  },
  mounted() {

  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  },
	methods: {
    clickMk(){
      if(this.isBgmPlaying){
        return;
      }
      if(JSON.parse(localStorage.getItem('BackgroundMusic'))){
        this.isBgmPlaying = true
        this.startBackgroundMusic();
      }

    },
		// code判断
		returnCode (data,callback) {
      let queryParams = this.$route.query;
			let code = data.code;
      console.log(code)
      //callback();
			if(code == 1){
				this.showLoad = false;
				callback();
			}else if(code==101){
				this.showLoad = false;
        this.$router.push({path:'/land',query: {...queryParams}})
			}else{
				this.showLoad = false;
				this.$utils.alertText(data.msg,80);
			}
		},
    handleGlobalClick(event) {
      // 如果点击的是不需要触发音乐的元素，则返回
      if (event.target.closest('.kai')) {
        return;
      }
      console.log('全局点击事件:')
      if (localStorage.getItem('BackgroundMusic') === 'true'){
        this.startBackgroundMusic()
      }
    },
    startBackgroundMusic() {
      this.audioService.play('bgm.main', { loop: true })
        .then(() => {
          this.isBgmPlaying = true;
          console.log('背景音乐开始播放');
          // 可选：将播放状态保存到本地存储
          localStorage.setItem('BackgroundMusic', 'true');
        })
        .catch(e => {
          console.error('背景音乐播放失败:', e);
          this.isBgmPlaying = false;
          localStorage.setItem('BackgroundMusic', 'false');
        });
    },
    stopBackgroundMusic() {
      this.isBgmPlaying = false;
      this.audioService.stopBackground();
      localStorage.setItem('BackgroundMusic', 'false');
    },
		loadModal(isShow){
			let that = this;
			that.showLoad = isShow;
		}
	}
}
</script>

<style>
	@import "./style/style.css";
	.modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
	.modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
	.modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);}
	.loadCont p{color:#fff;margin:10px 0 0;}
</style>



// WEBPACK FOOTER //
// src/App.vue